import request from '@/utils/request'

const biddingDogApi = process.env.VUE_APP_BIDDOG_API

// 分页查询公告
export function getNoticePageApi(params) {
  return request({
    url: biddingDogApi + '/mark/notices/page',
    method: 'get',
    params
  })
}

// 查询公告
export function getNoticeApi(noticeId) {
  return request({
    url: biddingDogApi + `/mark/notices/${noticeId}`,
    method: 'get'
  })
}

// 根据采购ID查询公告列表
export function getNoticeListByPurchaseIdApi(purchaseId) {
  return request({
    url: biddingDogApi + `/mark/purchases/${purchaseId}/notices`,
    method: 'get'
  })
}

// 查询公告详情
export function getNoticesDetailApi(noticeId) {
  return request({
    url: biddingDogApi + `/mark/notices/${noticeId}`,
    method: 'get'
  })
}
